export type TestimonialCarouselData = {
  name: string
  designation: string
  before: string
  after: string
  thumbnailText: string
  videoLink: string
}

export const testimonialCarouselList = [
  {
    name: "Saratha",
    designation: "Elementary STEM Teacher",
    before:
      "I was new to teaching and needed a lot of confidence as well as resources to pursue my teaching career.",
    after:
      "After enrolling in PgCTL, I have started to believe in myself as a teacher and use the various teaching resources to improve my skills.",
    thumbnailText:
      "I got placed in Kalamazoo Public School in the USA because of Suraasa.",
    videoLink: "https://youtu.be/gt8DSqD4kQc?si=YQEKnU9ORzSsi4-M",
  },
  {
    name: "Sruthi",
    designation: "Secondary Mathematics Teacher",
    before:
      "I was working as a Support Teacher and I did not know how to use technology in my classroom.",
    after:
      "I got a new job and a 50% increment in my salary. I also received appreciation from my Head for use of technology and data of my learners in my teaching and learning.",
    thumbnailText:
      "The interview skills & pedagogical skills gained from the course made me confident to get a job in Dubai!",
    videoLink: "https://youtu.be/wZgh2Hac980?si=ceFhKvRaLAnDCMEL",
  },
  {
    name: "Jeslin John",
    designation: "Teacher Assistant",
    before:
      "I was struggling to find a teaching job in the UAE. I had no international teaching qualifications.",
    after:
      "Suraasa team shared my profile with good schools in the UAE and I landed in a job even before I completed my course.",
    thumbnailText:
      "The mock interviews and training helped me land a job in UAE!",
    videoLink: "https://youtu.be/j3z6-QFoyTs?si=cpi8h4yvQbj4CScI",
  },
  {
    name: "Komal Mule",
    designation: "Computer Teacher",
    before:
      "I was unaware about the different teaching styles and methods. I only knew how to teach using blackboards and power-point presentations.",
    after:
      "I can see a lot of difference in my teaching methodologies after I enrolled in Suraasa.",
    thumbnailText: "I got an employment opportunity in the UAE.",
    videoLink: "https://youtu.be/HpYbLbEcuEI?si=0ULUDCL_bgKVPQpm",
  },
  {
    name: "Nishat",
    designation: "Business Teacher",
    before:
      "I moved to Dubai and was looking for a career progression. I was looking for a platform that would increase my employability.",
    after:
      "The concepts I learned have helped me immensely in improving my teaching and settle in my new environment",
    thumbnailText:
      "I got a job in Dubai and even received positive feedback from my superiors.",
    videoLink: "https://youtu.be/5BLngCz-KeA?si=rdE7ZiTz2M5s0Tzg",
  },
  {
    name: "Vertika Mishra",
    designation: "Headmistress",
    before:
      "I needed to work on my confidence and my skills. I also needed to learn new skills for modern students.",
    after:
      "I was not only promoted from Teacher to The Headmistress but I also achieved an incredible career growth with increase in salary and recognition from my peers.",
    thumbnailText:
      "I was successfully promoted from Teacher to The Headmistress",
    videoLink: "https://youtu.be/LzcXfWp7EYw?si=OrhdMgSst3I91s1q",
  },
  {
    name: "Amzad Khan",
    designation: "Mathematics Teacher",
    before:
      "I already have 12 years of experience and teaching qualifications. But I was eager to learn and grow more in my career.",
    after:
      "I learnt so many new techniques, new skills, new methodologies after enrolling with PgCTL. It has been such a life-changing experience.",
    thumbnailText:
      "I got promoted to the 2nd Incharge of the school with a 40% increment in my salary.",
    videoLink: "https://youtu.be/ho_Q7wlHp3g?si=Akr6tFCH-S_kfiZD",
  },
  {
    name: "Ola Khalil",
    designation: "English Teacher",
    before:
      "I was looking for Professional Development to expand my knowledge and skills in teaching.",
    after:
      "I have got increment and recognition from my school. Additionally, it has helped me create best learning environment for my students and experience positive changes in my teaching styles and methods.",
    thumbnailText:
      "I was surprised to see how PgCTL is so update to date with today's teaching requirements and classroom needs.",
    videoLink: "https://youtu.be/Q60yIomGXak?si=C7tafsWEwE8XtrI_",
  },
  {
    name: "Fatima Wasim",
    designation: "Teacher, Humanities Department",
    before:
      "I was using traditional methods of teaching. I was also lacking knowledge about different modern tools and techniques.",
    after:
      "Now, I've become a modern and a better teacher. I started applying modern tools and techniques of teaching which I've learnt in Suraasa.",
    thumbnailText:
      "I was awarded the Microsoft Innovative Educator Expert recognition certificate. I also qualified for the teaching license in Dubai.",
    videoLink: "https://youtu.be/5pz-UwOX37E?si=QVMOQww4nGZh2ovP",
  },
  {
    name: "Roger",
    designation: "Engineering Teacher",
    before:
      "Lacked structured methods to implement ethical values, effective feedback, and technology integration in the workplace.",
    after:
      "Mastered the use of technology for Teaching and Learning, sharing knowledge on how to use Excel with colleagues, leading to more efficient work processes and recognition as a valuable team member.",
    thumbnailText:
      "I’ve learned to hold my values, give constructive feedback, and use technology effectively",
    videoLink: "https://youtu.be/2JbQ2ZEGaBs?si=W8_Mf7tTuqshfMgY",
  },
  {
    name: "Tulsi Dutta",
    designation: "Pre-primary Teacher",
    before:
      "I was not satisfied with my job as a teacher and wanted to upskill.",
    after:
      "Suraasa satisfied my thirst of learning and helped me get a job at a reputed school.",
    thumbnailText:
      "I learned new teaching methodologies and 50% salary hike from my superiors.",
    videoLink: "https://youtu.be/ukCq3xcU29s?si=803c7U9d2q1iwdDd",
  },
  {
    name: "Aarti Poojare",
    designation: "Pre-primary Teacher",
    before:
      "I knew there was a need to employ new learning styles and taxonomies in my lesson plans.",
    after:
      "I enhanced my teaching skills and pedagogical knowledge. I am now able to create effective lesson plans.",
    thumbnailText:
      "I have seen tremendous changes in my teaching methods after enrolling with Suraasa.",
    videoLink: "https://youtu.be/twC_nhf5Zd4?si=_lf-zPfiP0T0Y-aS",
  },
  {
    name: "Anju George",
    designation: "Elementary School Teacher",
    before:
      "Teaching was just a job for me before enroling with Suraasa. But it has become my life.",
    after:
      "I started implemented teaching theories and new methods of assessments, feedback & modern techniques in my classroom.",
    thumbnailText:
      "My students' parents are impressed by the initiatives I take for my students.",
    videoLink: "https://youtu.be/Kyw8xM5U_f8?si=l4BtpFS8PdMDCGSN",
  },
]
